export let TypeOfTeaching = /*#__PURE__*/function (TypeOfTeaching) {
  TypeOfTeaching["Snu"] = "snu";
  TypeOfTeaching["Foundamental"] = "foundamental";
  TypeOfTeaching["Specialize"] = "specialize";
  TypeOfTeaching["So"] = "so";
  TypeOfTeaching["Promsoc"] = "promsoc";
  TypeOfTeaching["EnsAut"] = "ensAut";
  return TypeOfTeaching;
}({});